module.exports = __webpack_public_path__ + "666fad79f30209140234b3a8316fb5c6.fbx";